import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { LocalizeRouterService } from 'localize-router';
import { environment as env } from 'src/environments/environment';
import { UtilityService } from '../services/utility.service';
import { AuthenticationService } from './authentication.service';
import { UserFactory } from './user.factory';
import * as moment from 'moment';
import Swal from 'sweetalert2';
import { TranstationFactory } from './translation.factory';
import { TranslateService } from '@ngx-translate/core';

const DATE_FORMAT_DEFAULT = 'DD MMM YYYY';

@Injectable()
export class LoginAuthGuard implements CanActivate {

  code: any;
  states: any;
  navigate: any;

  constructor(
    private authService: AuthenticationService,
    private route: Router,
    private userFactory: UserFactory,
    private localize: LocalizeRouterService,
    private utilityService: UtilityService,
    private transtationFactory: TranstationFactory,
    private translate: TranslateService,
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const code = state.root.queryParams.code;
    const refresh = state.root.queryParams.refresh;

    console.log('refresh', refresh);

    if (!this.authService.isAuthenticated()) {
      if (code != undefined) {
        this.userFactory.saveToken(code);
        this.userFactory.saveRefreshToken(refresh);
        this.authService.getAgentProfile().subscribe(res => {
          const profile = res['agentProfileDetail'];
          this.userFactory.saveProfile(profile.agentId);
          this.checkExpireDate(res);
          const url: any = this.localize.translateRoute(env.path.home);
          this.route.navigate([url], {
            queryParams: {
              return: url
            }
          });
        });
      } else {
        /* new log-in (adb2c) */
        if (env.isSso) {
          //const state = this.utilityService.generateStateSSO();
          const urlLoginWithADB2C = `${env.ssoLoginUrl}?` + `${env.responseType}` + `&state=${btoa(state.url)}` + `&${env.scope}` + `&${env.clientId}` + `&${env.redirectPath}`;
          console.log('url: ', urlLoginWithADB2C);
          localStorage.setItem('state', state.url)
          window.location.href = urlLoginWithADB2C;
          return false;
        } else {
          /* old */
          return true;
        }
      }
    } else {
      const url: any = this.localize.translateRoute(env.path.home);
      this.route.navigate([url], {
        queryParams: {
          return: state.url
        }
      });
      return false;
    }
  }

  checkExpireDate(res) {
    if (res['isPass'] === 'Y') {
      const nowDate = moment(new Date()).startOf('day');
      const date = new Date(res.agentProfileDetail.licenseExpired);
      let expireDate = moment(date);
      const years = expireDate.diff(nowDate, 'years');
      const months = expireDate.diff(nowDate, 'months') - (years * 12);
      const days = expireDate.diff(nowDate, 'days');

      expireDate = this.translate.currentLang === 'th' ? expireDate.add(543, 'year') : expireDate;
      const dateStr = expireDate.format(DATE_FORMAT_DEFAULT);

      const massage = this.transtationFactory.get('expire_warning_text')
        + days + this.transtationFactory.get('expire_warning_text_day')
        + dateStr;

      if (days <= 60) {
        Swal.fire({
          title: this.transtationFactory.get('expire_warning'),
          text: massage,
          type: 'warning',
          confirmButtonText: this.transtationFactory.get('button.close')
        });
      }
    }
  }
}
